import { useEffect } from 'react';

const useSetDocumentTitle = (title?: string, subscriptionName?: string, proposalName?: string) => {
  useEffect(() => {
    if (title && proposalName) {
      document.title = `${title} - ${proposalName} - levvr`;
    } else if (title && subscriptionName) {
      document.title = `${title} - ${subscriptionName} - levvr`;
    } else {
      document.title = 'levvr'; // Default title
    }
  }, [title, subscriptionName, proposalName]);
};

export default useSetDocumentTitle;
